import { render } from "./PickerDay.vue?vue&type=template&id=23c95c37"
import script from "./PickerDay.vue?vue&type=script&lang=js"
export * from "./PickerDay.vue?vue&type=script&lang=js"
script.render = render

export default script